import { IOpFinder, IOpKomponent, IOpSurowiecHandlowy } from "./IOp"

export class  OpKomponent implements  IOpKomponent {
    
    _id:any
    text:string = ""
    komponent_id: string = ""
    komponent_text:string = ""
    komponent_typ: string = ""
    komponent_nazwa: string = ""
    komponent_exact: number = 0
    komponent_exact_metry: number = 0
    komponent_kolor: string = ""
    komponent_polysk: string = ""
    komponent_podklad: string = ""
    komponent_grubosc_podkladu: number = 0
    komponent_cena: number = 0
    komponent_jm: string = ""
    komponent_wydatek: number = 0
    komponent_lead_time: number = 0
    surowiec_handlowy: IOpSurowiecHandlowy | undefined = undefined
    zbiorczy: number = 0

}
